<template>
  <div class="pie">
    <div class="chart-wrap">
      <div class="chart-header flex-wrap">
        <div class="main-font-color title">{{ title }}</div>
        <div class="total">
          {{ desc }}
          <span class="main-font-color">{{ queryTotal }}</span>
        </div>
      </div>
      <div class="chart-body flex-wrap">
        <div ref="chart" class="chart-content" />
        <div class="item-list flex-wrap">
          <div
            v-for="item in queryData"
            :key="item.key"
            class="item-content fn-clear"
          >
            <div
              class="item-icon fn-left"
              :style="{ borderColor: item.itemStyle.color }"
            />
            <div class="item-info">
              <div class="item-title">{{ item.name }}</div>
              <div class="item-total">{{ item.value }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import echarts from 'echarts'
export default {
  name: 'Pie',
  props: {
    queryData: Array,
    queryTotal: Number,
    title: String,
    desc: String
  },
  data() {
    return {}
  },
  watch: {
    queryTotal() {
      this.drawPie()
    },
    queryData() {
      this.drawPie()
    }
  },
  mounted() {
    this.drawPie()
  },
  methods: {
    drawPie() {
      const pie = echarts.init(this.$refs.chart)
      pie.setOption({
        series: [
          {
            type: 'pie',
            radius: ['40%', '50%'],
            hoverAnimation: false,
            label: {
              normal: {
                formatter: '{b}:{d}%',
                lable: {
                  show: true,
                  position: 'inner',
                  formatter: '{b}\n{c}%'
                }
              },
              emphasis: {
                show: true,
                textStyle: {
                  fontSize: '16',
                  fontWeight: 'bold'
                }
              }
            },
            data: this.queryData
          }
        ]
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.chart-wrap {
  margin-bottom: 50px;
  width: 760px;
  .chart-header {
    background-color: #f0f3fa;
    height: 60px;
    line-height: 60px;
    padding: 0 30px;
    justify-content: space-between;
    .title {
      font-size: 16px;
    }
    .total {
      font-size: 14px;
    }
  }
  .chart-body {
    height: 350px;
    background-color: #fafafa;
    .chart-content {
      width: 460px;
      height: 350px;
    }
    .item-list {
      flex: 1;
      height: 100%;
      padding: 85px 50px;
      box-sizing: border-box;
      justify-content: space-between;
      align-content: space-between;
      flex-wrap: wrap;
      position: relative;
      :before {
        content: "";
        position: absolute;
        left: 0;
        top: 50%;
        transform: translate(0, -50%);
        width: 2px;
        height: 180px;
        background-color: #d9d9d9;
      }
      .item-content {
        width: 50%;
        .item-icon {
          box-sizing: border-box;
          width: 14px;
          height: 14px;
          border-radius: 50%;
          border-width: 3px;
          border-style: solid;
          border-color: #333;
        }
        .item-info {
          overflow: hidden;
          padding-left: 10px;
          font-size: 14px;
          .item-title {
            color: $color_black;
            margin-bottom: 10px;
          }
          .item-total {
            color: $color_normal;
          }
        }
      }
    }
  }
}
</style>
